// extracted by mini-css-extract-plugin
export default {"checkbox":"index-module__checkbox--7DNZt","checkbox--selected":"index-module__checkbox--selected--xjEg1","checkbox__icon":"index-module__checkbox__icon--f9QqP"};